<template>
  <path pid="0" d="M5.63 17.87A1 1 0 007 17.48a1 1 0 00-.39-1.36 7 7 0 1110.16-7.87 1 1 0 001 .75H19a4 4 0 01.8 7.92 1 1 0 10.4 2A6 6 0 0019 7h-.52a9 9 0 00-17.2.75A8.76 8.76 0 001 9.84v.31a9 9 0 004.63 7.72z"/><path pid="1" d="M16 17h-4.13l3-4.45a1 1 0 00-1.66-1.11l-4 6A1 1 0 0010 19h4.13l-3 4.44a1 1 0 101.66 1.11l4-6A1 1 0 0016 17z"/>
</template>
